









































































































// Vue
import { defineComponent, ref, Ref } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { DataTable } from '@/components/table'
import { Button } from '@/components/general'
import { FiltersWorkSheetMonthly } from '@/components/workSheetMonthly'
import { APP_URL_API } from '@/constants'
// service
import MonthlyPayrollService from '@/services/monthlyPayroll/monthlyPayrollService'

// Models
import { Paginator } from '@/models'
import { MonthlyPayrollModel } from '@/models/monthlyPayroll'

// utils
import { alerts } from '@/utils'

export default defineComponent({
  name: 'WorkSheetsMonthlyIndex',
  components: {
    PageHeader,
    FiltersWorkSheetMonthly,
    DataTable,
    Button
  },
  setup (props, { root: { $router } }) {
    const router = $router
    const URL_PDF = 'reports/consolidado'
    const title = 'Planilla Mensual'
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Planillas'
      },
      {
        text: 'Mensual',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
      currentPage: 1,
      total: 0,
      count: 0,
      perPage: 10
    })
    const loading = ref(false)
    const payrolls: Ref<MonthlyPayrollModel[]> = ref([])
    const filters: Ref<{ year: string; month: string }> = ref({
      year: '',
      month: ''
    })
    const headers = [
      {
        key: 'index',
        sortable: false,
        label: '#'
      },
      {
        key: 'year',
        sortable: true,
        label: 'Año'
      },
      {
        key: 'month',
        sortable: true,
        label: 'Mes'
      },
      {
        key: 'total',
        sortable: true,
        label: 'Total'
      },
      {
        key: 'actions',
        sortable: true,
        label: 'Acciones'
      }
    ]
    const isFiltersValid = () => {
      if (!filters.value.year || !filters.value.month) {
        return false
      }
      return true
    }
    const generate = () => {
      if (!isFiltersValid()) {
        return alerts.error('Debe completar todos los filtros')
      }
      return router.push({
        name: 'payroll-monthly',
        params: {
          ...filters.value
        }
      })
    }

    const getMonthlyPayrolls = async () => {
      loading.value = true
      const result = await MonthlyPayrollService.getAllWithPagination(pagination.value.perPage, pagination.value.currentPage)
      pagination.value = {
        currentPage: result.pagination.currentPage,
        count: result.pagination.count,
        perPage: result.pagination.perPage,
        total: result.pagination.total
      }
      payrolls.value = result.objects
      loading.value = false
    }
    getMonthlyPayrolls()

    const printReport = (id) => {
      window.open(`${APP_URL_API}${URL_PDF}?&consolidado=${id}`, '_blank')
    }

    const deletePayroll = async (id: number) => {
      try {
        const confirmed = await alerts.confirm('Seguro de eliminar la planilla seleccionada?')
        if (confirmed) {
          loading.value = true
          await MonthlyPayrollService.remove(id)
          loading.value = false
          alerts.success()
          setTimeout(() => {
            getMonthlyPayrolls()
          }, 100)
        }
      } catch (e) {
        alerts.error(String(e))
      }
    }

    return {
      title,
      breadcrumbs,
      pagination,
      printReport,
      loading,
      headers,
      generate,
      filters,
      payrolls,
      deletePayroll
    }
  }
})
